import { Link } from "react-router-dom";

const stats = [
  { value: "12000+", label: "收录同人作品" },
  { value: "24", label: "主题分类目录" },
  { value: "38万", label: "月活跃读者" },
  { value: "860+", label: "社区推荐资源" },
];

export default function Hero() {
  return (
    <section className="relative flex min-h-[640px] md:min-h-[720px] w-full items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=epic%20dark%20ninja%20village%20skyline%20silhouette%20under%20a%20vast%20moody%20night%20sky%2C%20glowing%20ember%20orange%20fire%20and%20shuriken%20particles%20swirling%20upward%2C%20warm%20charcoal%20and%20amber%20gradient%2C%20cinematic%20anime%20key%20visual%2C%20dramatic%20backlighting%20and%20deep%20shadows%2C%20atmospheric%20and%20stylized&width=1600&height=900&seq=hero-naruto&orientation=landscape"
          alt="火影忍者同人作品导航背景图"
          title="火影忍者同人作品导航"
          className="h-full w-full object-cover object-center"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-background-50/80 via-background-50/60 to-background-50" />

      <div className="relative z-10 mx-auto w-full max-w-7xl px-4 md:px-6 pb-16 pt-28 text-center md:pt-32">
        <span className="inline-flex items-center gap-2 rounded-full border border-primary-500/40 bg-primary-500/10 px-4 py-1.5 text-xs font-medium text-primary-300">
          <i className="ri-fire-line" />
          火影忍者同人作品合集 · 社区推荐 · 导航目录
        </span>
        <h1 className="mx-auto mt-6 max-w-3xl font-heading text-3xl font-bold leading-tight text-foreground-950 md:text-5xl">
          一站式追更火影忍者同人
          <span className="text-primary-400">，追更不迷路</span>
        </h1>
        <p className="mx-auto mt-5 max-w-2xl text-sm leading-relaxed text-foreground-400 md:text-base">
          这里聚合火影忍者同人作品、合集与社区导航，按目录整理热门推荐。从经典长篇到冷门短篇持续更新，帮你快速找到想看的同人内容。
        </p>
        <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
          <Link
            to="/works"
            className="flex w-full items-center justify-center gap-2 rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 sm:w-auto whitespace-nowrap"
          >
            <i className="ri-book-open-line" />
            浏览同人作品库
          </Link>
          <Link
            to="/faq"
            className="flex w-full items-center justify-center gap-2 rounded-md border border-background-300/70 bg-background-100/50 px-6 py-3 text-sm font-medium text-foreground-300 transition-colors hover:border-primary-500/50 hover:text-primary-300 sm:w-auto whitespace-nowrap"
          >
            追更常见问题
            <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <dl className="mx-auto mt-12 grid max-w-3xl grid-cols-2 gap-4 sm:grid-cols-4">
          {stats.map((s) => (
            <div key={s.label} className="rounded-lg border border-background-300/60 bg-background-100/60 px-4 py-4 backdrop-blur-sm">
              <dt className="order-2 mt-1 text-xs text-foreground-400">{s.label}</dt>
              <dd className="font-heading text-xl font-bold text-primary-300 md:text-2xl">{s.value}</dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}